import { render, staticRenderFns } from "./SideNavLayout.vue?vue&type=template&id=00370a4c&scoped=true"
import script from "./SideNavLayout.vue?vue&type=script&lang=js"
export * from "./SideNavLayout.vue?vue&type=script&lang=js"
import style0 from "./SideNavLayout.vue?vue&type=style&index=0&id=00370a4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00370a4c",
  null
  
)

export default component.exports